"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const React = __importStar(require("react"));
const FreePlanButton = ({ onClick }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(snap_ui_1.LabelButton, { "data-testid": "free-plan-button-desktop", className: "sui-hidden d:sui-inline-flex", labelText: "Start with a free plan", variantType: "secondary", icon: "chevron_right", iconPosition: "right", onClick: onClick }),
        React.createElement(snap_ui_1.LabelButton, { "data-testid": "free-plan-button-mobile", className: "sui-w-full d:sui-hidden", labelText: "Start with a free plan", variantType: "secondary", icon: "chevron_right", iconPosition: "right", onClick: onClick })));
};
exports.default = FreePlanButton;
